<div class="grid-container padding-y-4">
  <div class="grid-row">
    <div class="col-12">
        <legend class="usa-legend usa-legend--large">Login History Report</legend>
    </div>
  </div>
  <form [formGroup]="loginForm">
    <div class="grid-row grid-gap" *ngIf="isSysAdmin">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label for="usertype" class="usa-label">Select User Type<abbr title="required"
            class="usa-hint usa-hint--required">*</abbr></label>
        <select id="user_type" class="usa-select maxw-full" formControlName="userType" (change)="changeUserType($event)" name="userType">
          <option value=''>Choose...</option>
          <option value='A'>Agency</option>
          <option value='T'>TSP </option>
        </select>
      </div>
    </div>

    <div class="grid-row grid-gap" *ngIf="userType == 'A' && isSysAdmin">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label class="usa-label" for="customer_name_new">Agency Name<abbr title="required"
          class="usa-hint usa-hint--required">*</abbr></label>
        <ng-template #agencySearchTemplate let-model="item" let-index="index">
          {{model.agencyBureauName}} - {{model.agencyCode}}
        </ng-template>
        <input id="agency_name" class="usa-input maxw-full" formControlName='agency' placeholder="Select agency"
          [typeaheadOptionsInScrollableView]="10" [typeaheadOptionsLimit]="300" [typeaheadMinLength]="0"
          (typeaheadOnSelect)="changeAgency($event)" typeaheadOptionField="agencyBureauName"
          [typeahead]="agencyMaster" [typeaheadItemTemplate]="agencySearchTemplate"
          [typeaheadScrollable]="true">
      </div>

      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label class="usa-label" for="bureau_name_new">Bureau Name<abbr title="required"
            class="usa-hint usa-hint--required">*</abbr></label>
          <select id="bureau_name_new" class="maxw-full usa-select" formControlName="bureauCode" (change)="changeBureau($event)"
            name="bureauCode">
            <option value='' selected disabled>Choose...</option>
            <option *ngFor='let b of bureauMaster' [value]="b.bureauCode">{{b.agencyBureauName}} -
              {{b.bureauCode}} </option>
          </select>
      </div>

      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label class="usa-label" for="customer">Customer</label>
        <select id="customer" class="maxw-full usa-select" formControlName="customer" name="customer"
          (change)="ROChange($event)">
          <option value='null' selected disabled>Choose...</option>
          <option *ngFor='let c of customerList' [value]="c.organizationId">{{c.city}},{{c.stateName}} -
            {{c.lastName}}, {{c.firstName}}</option>
        </select>
      </div>

    </div>

    <div class="grid-row grid-gap" *ngIf="userType == 'T' && isSysAdmin">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label class="usa-label" for="tsp">TSP<abbr title="required"
          class="usa-hint usa-hint--required">*</abbr></label>
        <select id="tsp" class="maxw-full usa-select" formControlName="tsp" name="tsp" (change)="changeTsp($event)">
          <option value='null' selected disabled>Choose...</option>
          <option *ngFor='let c of carrierList' [value]="c.carrierId">{{c.scac}} - {{c.scacName}}</option>
        </select>
      </div>
    </div>

    <div class="padding-y-2" *ngIf="showReportFlag">
      <div class="grid-row grid-gap padding-bottom-205">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
          <img src="assets/uswds/img/usa-icons/file_download.svg" alt="user_icon"> Right click on the report and select the appropriate options to export.
        </div>
      </div>
      <ag-grid-angular class="ag-theme-alpine" style="height: 400px;" [rowData]="loginHistoryList"
        [domLayout]="domLayout" [pagination]="true" [excelStyles]="excelStyles"
        [paginationPageSize]="paginationPageSize" [columnDefs]="loginRptColumnDefs"
        [getRowHeight]="getRowHeight">
      </ag-grid-angular>
    </div>

  </form>
</div>